var map = {
	"./blog_title_img.svg": 644,
	"./cards.png": 7676,
	"./close_icone.svg": 9196,
	"./commision_not_found.svg": 800,
	"./crypto_1.png": 1030,
	"./crypto_2.png": 1709,
	"./crypto_3.png": 5556,
	"./crypto_4.png": 5499,
	"./crypto_5.png": 146,
	"./crypto_6.png": 5289,
	"./crypto_7.png": 464,
	"./crypto_8.png": 4087,
	"./datapicer.svg": 3964,
	"./en-En.svg": 5042,
	"./facebook.svg": 3479,
	"./facebook_login.png": 9127,
	"./facebook_ref.svg": 6437,
	"./favourite.svg": 632,
	"./favourite_list_icon.svg": 2117,
	"./flags.png": 9048,
	"./flags@2x.png": 5936,
	"./flags_country.png": 2771,
	"./flags_country@2x.png": 6205,
	"./footer_defens.png": 3502,
	"./footer_secure.png": 8470,
	"./google_login.png": 7930,
	"./instagram_ref.svg": 9607,
	"./linkedin_ref.svg": 1251,
	"./mingcute_ref.svg": 2619,
	"./notifications.svg": 7497,
	"./phone.svg": 6345,
	"./profile_download.svg": 8625,
	"./promotions.svg": 6885,
	"./reset_success.svg": 1916,
	"./search.svg": 4343,
	"./sign_promocode_icone.png": 7144,
	"./sign_promocode_icone.svg": 8142,
	"./sitebar_1.svg": 9013,
	"./sitebar_10.svg": 7855,
	"./sitebar_2.svg": 7766,
	"./sitebar_3.svg": 4887,
	"./sitebar_4.svg": 5080,
	"./sitebar_5.svg": 3001,
	"./sitebar_6.svg": 2250,
	"./sitebar_7.svg": 6443,
	"./sitebar_8.svg": 8828,
	"./sitebar_9.svg": 9453,
	"./slots.svg": 2734,
	"./sport.png": 3323,
	"./touranments.svg": 8939,
	"./twitter.svg": 8592,
	"./valid-big.png": 7942,
	"./youtube.svg": 2054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8157;